import { useUserStore } from '@/stores/UserStore'

// Insights is built on the new design and has no legacy version; a link or a typed URL from a legacy dealer
// lands on Home instead.
const insightsGuard = () => (useUserStore().isNewDesign ? true : '/')

export default [
  {
    path: '/insights',
    name: 'Insights',
    meta: {
      requireAuth: true,
      requireFields: true,
    },
    component: () => import('@/views/Insights/index.vue'),
    beforeEnter: insightsGuard,
  },
  {
    // `/insights/{report slug}/{insight slug}` — the API's own slugs, so a card's CTA (`cta_url`) lands here as
    // is. Any slug matches: the report page asks the API, shows its "not found" for an unknown report, and
    // sends a missing or unknown tab to the report's first one.
    path: '/insights/:reportSlug/:insightSlug?',
    name: 'InsightsReport',
    meta: {
      requireAuth: true,
      requireFields: true,
    },
    component: () => import('@/views/InsightsReport/index.vue'),
    beforeEnter: insightsGuard,
  },
]
